import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendAsUrgent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 87 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			width: 83,
			height: 145,
			rx: 11,
			fill: "#281E38"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 14,
			width: 73,
			height: 113,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5002 43.575C30.2936 43.575 19.5752 53.6235 19.5752 66.0046C19.5752 73.2719 21.0705 77.9671 27.0518 83.9484L43.5002 97.4062V88.4343C56.7068 88.4343 67.4252 78.3858 67.4252 66.0046C67.4252 53.6235 56.7068 43.575 43.5002 43.575Z",
			fill: "white",
			stroke: "#FF5E84",
			strokeWidth: 4,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5 54.45L43.5 69.675",
			stroke: "#FF5E84",
			strokeWidth: 4,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5 74.025L43.5 78.375",
			stroke: "#FF5E84",
			strokeWidth: 4,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSendAsUrgent);
export default ForwardRef;
